<template>
  <section>
    <div class="loadingFull" v-if="loading"></div>
    <div class="movie" v-else v-on:mousemove="mouseMoved" v-on:mouseleave="mouseLeave">
      <div class="movie-title" :class="{hidden: titleHidden}">
        <div v-on:click="goBack" class="backBtn"></div>
        Before You Eat The Movie
      </div>
      <VuePlyr ref="video" :options="{ captions: { active: true, language: 'auto', update: false } }">
        <video>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/2160-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="2160"/>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/1440-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="1440"/>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/1080-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="1080"/>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/720-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="720"/>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/480-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="480"/>
          <source src="https://storage.googleapis.com/before-you-eat/bye-dc-clean-version/360-BYE-DC-clean-version_.mp4"
            type="video/mp4" size="360"/>
          <track kind="captions" label="English" srclang="en" default
            src="/subtitles/Before_You_Eat_The_Movie_Clean.en.vtt"/>
          <track kind="captions" label="Bahasa Indonesia" srclang="id"
            src="/subtitles/Before_You_Eat_The_Movie_Clean.id.vtt"/>
        </video>
      </VuePlyr>
    </div>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  name: 'movieDetail',
  components: { VuePlyr },
  data() {
    return {
      loading: true,
      scrolled: false,
      titleHidden: false,
      timer: null,
      savingTime: false,

      lang: 'id',
      langCode: 'id-id',
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    goBack() {
      this.$router.back();
    },
    hideTittle() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.titleHidden = true;
      }, 2000);
    },
    mouseMoved() {
      this.titleHidden = false;
      this.hideTittle();
    },
    mouseLeave() {
      this.titleHidden = true;
    },
    saveTime() {
      if (this.savingTime) return;
      this.savingTime = true;
      localStorage.setItem('bye_movie_full_ts', this.$refs.video.player.currentTime);
      const { key } = this.$route.query;
      this.$http.post(this.$config.uri('misc/1/watch-second'), { key, seconds: this.$refs.video.player.currentTime }).then((r) => {
        setTimeout(() => {
          this.savingTime = false;
        }, 5000);
      });
    },
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    const { code } = this.$route.params;
    if (code !== 'before-you-eat-the-movie') {
      window.location.href = `${this.$config.appPath}${this.langCode}/not-found`;
      return;
    }


    /**
     * Validate key
     *
     */
    const { key } = this.$route.query;
    this.$http.post(this.$config.uri('misc/1/validate-movie-access'), { key }).then((r) => {
      if (r.data.status !== 200) {
        window.location.href = `${this.$config.appPath}${this.langCode}/not-found`;
        return;
      }

      this.loading = false;

      setTimeout(() => {
        const v = this.$refs.video.player;
        const tsStr = localStorage.getItem('bye_movie_full_ts');
        let ts = (tsStr) ? Number(tsStr) : 0;
        if (Number.isNaN(ts)) ts = 0;
        v.once('playing', () => {
          v.currentTime = ts;
        });
        v.on('timeupdate', (e) => {
          if (v.currentTime > 10) this.saveTime();
        });
        v.play();
      });

      this.hideTittle();
    });
  },
};
</script>

<style scoped lang="scss">
.movie{
  height: 100vh;
  position: relative;
  overflow: hidden;
  .movie-title{
    position: absolute;
    z-index: 3;
    color: #fff;
    left: 0; top: 0; right: 0;
    font-size: 30px;
    font-weight: 500;
    background-image: linear-gradient(rgba(0,0,0,.64), transparent);
    padding: 16px 30px;
    display: flex;
    align-items: center;
    transition: all .3s ease;
    @media (max-width: 1480px) {
      font-size: 24px;
    }
    @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 20px;
    }
    &.hidden{
      transform: translateY(-100%);
    }
    .backBtn{
      width: 44px; height: 44px;
      background-image: url(../assets/arrow-prev.png);
      background-size: 28px auto;
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 20px;
      margin-top: -3px;
      transition: all .3s ease;
      border-radius: 50%;
      cursor: pointer;
      @media (max-width: 768px) {
        width: 40px; height: 40px;
        background-size: 24px auto;
        margin-right: 10px;
        margin-top: -2px;
      }
      &:hover{
        background-color: rgba(0, 0, 0, .34);
      }
    }
  }
}
</style>
